import { z } from 'zod';
import { themeImportQuestionSchema } from './theme-import-history.contract';

const metaSchema = z.object({
  request_id: z.string().uuid(),
  served_at: z.string().datetime(),
}).strict();

export const addThemeQuestionResponseSchema = z.object({
  error: z.literal(false),
  status: z.literal(201),
  message: z.literal('THEME_QUESTION_ADDED'),
  data: themeImportQuestionSchema,
  meta: metaSchema,
}).strict();

export const deactivateThemeQuestionsResponseSchema = z.object({
  error: z.literal(false),
  status: z.literal(200),
  message: z.literal('THEME_QUESTIONS_DEACTIVATED'),
  data: z.object({ deactivated: z.number().int().min(1).max(200) }).strict(),
  meta: metaSchema,
}).strict();

export const reactivateThemeQuestionsResponseSchema = z.object({
  error: z.literal(false),
  status: z.literal(200),
  message: z.literal('THEME_QUESTIONS_REACTIVATED'),
  data: z.object({ reactivated: z.number().int().min(1).max(200) }).strict(),
  meta: metaSchema,
}).strict();

export const deleteThemeQuestionsResponseSchema = z.object({
  error: z.literal(false),
  status: z.literal(200),
  message: z.literal('THEME_QUESTIONS_DELETED'),
  data: z.object({ deleted: z.number().int().min(1).max(200) }).strict(),
  meta: metaSchema,
}).strict();

export const deleteThemeQuestionsInputSchema = z.object({
  questionIds: z.array(z.string().regex(/^[0-9a-fA-F]{24}$/)).min(1).max(200)
    .refine((ids) => new Set(ids.map((id) => id.toLowerCase())).size === ids.length),
  password: z.string().min(1).max(200),
}).strict();

export const deactivateThemeImportResponseSchema = z.object({
  error: z.literal(false),
  status: z.literal(200),
  message: z.literal('THEME_IMPORT_DEACTIVATED'),
  data: z.object({ deactivated: z.number().int().nonnegative() }).strict(),
  meta: metaSchema,
}).strict();

export const importThemeQuestionsResponseSchema = z.object({
  error: z.literal(false),
  status: z.literal(200),
  message: z.literal('THEME_QUESTIONS_IMPORTED'),
  data: z.object({
    added: z.number().int().min(0).max(500),
    skipped: z.number().int().min(0).max(500),
  }).strict(),
  meta: metaSchema,
}).strict();

export const addThemeQuestionInputSchema = z.object({
  questionText: z.string().trim().min(1).max(2000),
  language: z.string().regex(/^[\p{L}\p{M}0-9_-]{1,40}$/u),
  domain: z.string().trim().max(255).optional(),
  source: z.string().trim().max(255).optional(),
}).strict();

export type AddThemeQuestionInput = z.infer<typeof addThemeQuestionInputSchema>;
